import { itemAt } from '../../lib/zones';
import { ZONE_PALETTES } from '../../theme/tokens';
import styles from './sportSettings.module.css';

export function ZoneStrip({ title, labels, model }: { title: string; labels: string[]; model: 'pace' | 'hr_lthr' }) {
  return (
    <div className={styles.zonesWrap}>
      {/* The list carries the title as its name; hidden here so it is read once. */}
      <p className={styles.zonesTitle} aria-hidden="true">{title}</p>
      <ul className={styles.zoneStrip} aria-label={title}>
        {labels.map((label, i) => (
          <li key={label} style={{ background: itemAt(ZONE_PALETTES[model], i) }}>{label}</li>
        ))}
      </ul>
    </div>
  );
}
